/// <amd-module name="Release/WorkItemReleaseLinks/ReleaseState" />
import * as React from "react";
import {
    EnvironmentStatus,
    ReleaseEnvironment,
} from "Release/Client/Contracts/Release";
import { Icon } from "VSSUI/Icon";
import { Tooltip } from "VSSUI/TooltipEx";
import { css } from "VSSUI/Util";
import { ILinkDisplayData } from "Wit/WorkItemLinksRegistration/Contracts";
import { DefaultLinkTypeState } from "Wit/WorkItemLinksRegistration/Components";

export function ReleaseState({ link }: { link: ILinkDisplayData }) {
    const releaseEnvironment = link.additionalData?.releaseEnvironment as
        | ReleaseEnvironment
        | undefined;
    const classAndIconByStatus = React.useRef(
        new Map<EnvironmentStatus, { className: string; iconName: string }>([
            [
                EnvironmentStatus.NotStarted,
                {
                    className: "info-text",
                    iconName: "Clock",
                },
            ],
            [
                EnvironmentStatus.Scheduled,
                {
                    className: "info-text",
                    iconName: "Clock",
                },
            ],
            [
                EnvironmentStatus.Queued,
                {
                    className: "info-text",
                    iconName: "Clock",
                },
            ],
            [
                EnvironmentStatus.InProgress,
                {
                    className: "info-text",
                    iconName: "Clock",
                },
            ],
            [
                EnvironmentStatus.Canceled,
                {
                    className: "error-text",
                    iconName: "StatusErrorFull",
                },
            ],
            [
                EnvironmentStatus.Rejected,
                {
                    className: "error-text",
                    iconName: "StatusErrorFull",
                },
            ],
            [
                EnvironmentStatus.Undefined,
                {
                    className: "error-text",
                    iconName: "StatusErrorFull",
                },
            ],
            [
                EnvironmentStatus.PartiallySucceeded,
                {
                    className: "warning-text",
                    iconName: "CompletedSolid",
                },
            ],
            [
                EnvironmentStatus.Succeeded,
                {
                    className: "success-text",
                    iconName: "CompletedSolid",
                },
            ],
        ])
    ).current;

    if (!releaseEnvironment) {
        return <DefaultLinkTypeState link={link} />;
    }

    const { className, iconName } =
        classAndIconByStatus.get(releaseEnvironment.status) ??
        classAndIconByStatus.get(EnvironmentStatus.Undefined)!;

    return (
        <div className={css("inline-flex-row release-link-status", className)}>
            <Icon className="icon-margin" iconName={iconName} />
            <Tooltip overflowOnly={true} text={link.state}>
                <span className="text-ellipsis release-link-status-text">
                    {link.state}
                </span>
            </Tooltip>
        </div>
    );
}
